'use strict'
import serviceBase from './serviceBase';
const SessionService = {
    SessionStore:(data) => serviceBase.post('/loginsession/store', data),
    SessionGet:(data) => serviceBase.post('/loginsession/getstore', data),
    SessionDestory:(data) => serviceBase.post('/loginsession/sessionDestory', data),
   
}
export default SessionService